import React from 'react';
import Form from '../../../../components/forms/utils/Form';
import SingleLineField from '../../../../components/forms/SingleLineField';
import {useMutation} from '@apollo/client';
import {UPDATE_WEBSITE} from '../../../../utils/api/website';
import {useOutletContext} from 'react-router-dom';
import ImageUploadField from '../../../../components/forms/ImageUploadField';
import MultiLineField from '../../../../components/forms/MultiLineField';
import FormItem from '../../../../components/forms/utils/FormItem';
import ColorPicker from '../../../../components/forms/ColorPicker';

interface AdertorialUIProps {
  id: string;
}

const AdertorialUI: React.FC<AdertorialUIProps> = ({ id }) => {
  const { website } = useOutletContext<any>();

  const { __typename, hostingType, path, ...defaultValues} = website.advertorialSite || {properties: '{ }'}
  const [updateWebsite] = useMutation(UPDATE_WEBSITE)

  const handleSubmit = async (values: any, changedValues: any) => {
    const advertorialSetup = hostingType ? {hostingType, path} : {}
    const advertorialSite = {...advertorialSetup, ...values}

    updateWebsite({
      variables: { id: website._id, record: {advertorialSite} }
    })
  }
  return (
    <Form
      defaultValues={defaultValues}
      className="mt-8 flex-1 relative overflow-y-auto focus:outline-none bg-white rounded-md py-6 px-6 sm:space-y-5"
      onSubmit={handleSubmit}
      submitButtonText="Save"
    >
      <SingleLineField
        label="Template name"
        htmlfor="templateName"
      />

      <ImageUploadField
        top
        label="Logo"
        name="logoImageId"
      />

      <FormItem
        label="Primary color"
      >
        <ColorPicker allowClear name='primaryColor' />
      </FormItem>

      <FormItem
        label="Secondary color"
      >
        <ColorPicker allowClear name='secondaryColor' />
      </FormItem>

      <MultiLineField
        label="Additional header code"
        htmlfor="headerCode"
        placeholder='Type here'
        rows={3}
      />

      <MultiLineField
        label="Additional footer code"
        htmlfor="footerCode"
        placeholder='Type here'
        rows={3}
      />

      <MultiLineField
        label="Additional variables"
        htmlfor="properties"
        placeholder='{ }'
        rows={3}
      />
    </Form>
  );
};

export default AdertorialUI;


